import { labelize } from 'buyside/util/arrayHelper';
import { underscore } from 'inflection';

const {
  allocatorFirmTypes,
  assetClassNames,
  aumRangeNames,
  catalystNames,
  certificationTypes,
  cities,
  compCategory,
  compFundStrategy,
  compIndustry,
  compTitle,
  countries,
  degreeTypes,
  employerProfileSupportingDocumentNames,
  esgs,
  fundFocuses,
  fundSizes,
  fundStrategyNames,
  fundTypeNames,
  geographyNames,
  globalMacros,
  ideaAttachmentTypes,
  investmentSituations,
  jobTypes,
  labelizedEmployerProfileTagGroups,
  quartiles,
  rankingCategories,
  sectorNames,
  totalCashCompRange,
  whitePaperAttachmentTypes,
  yearOfExp,
  yearSubmitted
} = require('buyside/util/constantsFromRails.json');

export const labelizedFilterListOptions = {
  allocatorFirmTypes: labelize(allocatorFirmTypes),
  assetClasses: labelize(assetClassNames),
  aumRanges: labelize(aumRangeNames),
  cashCompRanges: Object.entries<string>(totalCashCompRange).map(([key, value]) => ({
    value: key,
    label: value
  })),
  catalysts: labelize(catalystNames),
  certifications: labelize(certificationTypes),
  cities: labelize(cities.map(({ name }: { name: string }) => name)),
  compCategories: labelize(compCategory, true),
  compFundStrategies: labelize(compFundStrategy),
  compIndustries: labelize(compIndustry),
  compTitles: labelize(compTitle),
  countries: labelize(countries),
  esgs: labelize(esgs.map(({ name }: { name: string }) => name)),
  fundFocuses: labelize(fundFocuses),
  fundSizes: labelize(fundSizes),
  fundStrategies: labelize(fundStrategyNames),
  fundSupportingDocuments: labelize(employerProfileSupportingDocumentNames),
  fundTags: labelizedEmployerProfileTagGroups,
  fundTypes: labelize(fundTypeNames),
  geographies: labelize(geographyNames),
  globalMacros: labelize(globalMacros.map(({ name }: { name: string }) => name)),
  graduateDegrees: labelize(degreeTypes.graduate),
  ideaAttachmentChannelChecks: labelize(ideaAttachmentTypes['Channel Check']),
  ideaAttachmentFinancialModels: labelize(ideaAttachmentTypes['Financial Model']),
  ideaAttachmentSecondaryResearch: labelize(ideaAttachmentTypes['Secondary Research']),
  ideaViews: labelize(['Most Views', 'Average Views', 'Least Views']),
  investmentSituations: labelize(investmentSituations, true),
  membersIndexJobTitles: jobTypes.map((label: string) => ({
    value: underscore(label).replaceAll(' ', ''),
    label
  })),
  quartiles,
  rankingCategories: labelize(rankingCategories, true),
  sectors: labelize(sectorNames),
  undergradDegrees: labelize(degreeTypes.undergrad),
  whitePaperAttachmentFinancialModels: labelize(whitePaperAttachmentTypes.financial_model, true),
  whitePaperAttachmentSecondary: labelize(whitePaperAttachmentTypes.secondary, true),
  yearsOfExperience: yearOfExp.map((year: string) => ({ value: year.split(' ')[0], label: year })),
  yearSubmitted: labelize(yearSubmitted.map((year: string) => year.toString())),
  yesNo: labelize(['Yes', 'No'])
};
